import { DocumentationItemHeaderV2 } from "@supernova-studio/model";
import { z } from "zod";

export const DTODocumentationItemHeaderV2 = DocumentationItemHeaderV2;

export const DTODocumentationItemConfigurationV2 = z.object({
  showSidebar: z.boolean(),
  isPrivate: z.boolean(),
  isHidden: z.boolean(),
  header: DTODocumentationItemHeaderV2,
});

export type DTODocumentationItemHeaderV2 = z.infer<typeof DTODocumentationItemHeaderV2>;
export type DTODocumentationItemConfigurationV2 = z.infer<typeof DTODocumentationItemConfigurationV2>;
